import { Env } from '@env';
import { jwtDecode } from 'jwt-decode';
import React from 'react';
import { appleAuthHelpers, useScript } from 'react-apple-signin-auth';
import { useStyles } from 'react-native-unistyles';

import type { TxKeyPath } from '@/core';
import { Button } from '@/ui';
import { Icon } from '@/ui/icon';
import { Apple } from '@/ui/icons/apple';

interface AppleLoginProps {
  tx: TxKeyPath;
  onSuccess: (userId: string, identityToken: string, fullName?: string) => void;
  onPress?: () => void;
}

export const AppleLogin = ({ tx, onSuccess, onPress }: AppleLoginProps) => {
  const { theme } = useStyles();

  useScript(appleAuthHelpers.APPLE_SCRIPT_SRC);

  return (
    <Button
      leftIcon={
        <Icon
          type="naked"
          icon={<Apple />}
          stroke={theme.colors.icon.nakedColor}
          fillColor={theme.colors.icon.nakedColor}
          width={20}
          height={20}
        />
      }
      tx={tx}
      type="secondary"
      onPress={() => {
        onPress?.();

        appleAuthHelpers.signIn({
          authOptions: {
            clientId: 'com.eon.development.auth',
            scope: 'email name',
            redirectURI: `${Env.BASE_URL}auth/callback`,
            usePopup: true,
          },
          onSuccess: (response: any) => {
            const decodedToken = jwtDecode(response.authorization.id_token);

            onSuccess(
              decodedToken.sub,
              response.authorization.id_token,
              response.user?.name
                ? `${response.user.name.firstName} ${response.user.name.lastName}`
                : ''
            );
          },
          onError: (error: any) => console.error(error),
        });
      }}
      style={{ width: '100%' }}
    />
  );
};
